import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {AzureTaskSorting} from '../classes/azure-task-sorting';
import {RealtimeService} from './realtime/realtime.service';
import {WebsocketService} from './websocket/websocket.service';
import {RealtimeType} from './realtime/realtime-type.enum';

@Injectable({
    providedIn: 'root'
})
export class AzureTaskSortingService extends RealtimeService<AzureTaskSorting> {

    constructor(public apiService: ApiService, protected websocketService: WebsocketService) {
        super(websocketService, RealtimeType.azureTaskSorting, 'task_id');
    }

    itemInDaterange(sorting: AzureTaskSorting, fromDate: Date, toDate: Date) {
        return true;
    }
}
